<script setup lang="ts">
defineProps<{ title: string; description: string; icon?: `icon:${string}` }>();
</script>

<template>
  <div
    class="p-r6 lg:p-r12 gap-r2 absolute bottom-0 left-0 flex flex-col text-white select-auto"
  >
    <AppIcon
      v-if="icon"
      :name="icon"
      size="custom"
      class="size-r12 sm:size-r18 drop-shadow-xl drop-shadow-black"
    />
    <AppHeading tag="h2">
      {{ title }}
    </AppHeading>
    <AppParagraph>
      {{ description }}
    </AppParagraph>
  </div>
</template>
